export const formatCurrency = (amount: number): string => {
    if (typeof amount === 'number') {
        const formattedAmount = (Math.abs(amount) / 100).toFixed(2);
        return amount < 0 ? `-$${formattedAmount}` : `$${formattedAmount}`;
    }
    return "$ --"
};

export function formatNumber(value: number | string | undefined | null) {
    if (value == null || isNaN(Number(value))) return '-';
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 5,
    }).format(Number(value));
  }

export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

export function getIntegerAmount(displayAmount: string) {
    displayAmount = displayAmount.replace(/\$/g, '')
    if (displayAmount.length == 0) {
        return 0
    }
    let [integerPart, decimalPart] = displayAmount.split('.');
    if (decimalPart) {
        if (decimalPart.length < 2) {
            decimalPart = decimalPart + '0'
        }
        return parseInt(integerPart) * 100 + parseInt(decimalPart)
    } else {
        return parseInt(integerPart) * 100
    }
}

export const getDisplayAmount = (value: string) => {
    const cleanedValue = value.replace(/[^0-9.]/g, '');
    if (cleanedValue.length === 0) {
        return ''
    }
    if (cleanedValue.length > 1 && cleanedValue[0] === '0' && cleanedValue[1] !== '.') {
        console.log('1')
        return '$' + cleanedValue[1]
    }
    if (!cleanedValue.includes('.')) {
        return '$' + cleanedValue
    }
    let [integerPart, decimalPart] = cleanedValue.split('.');
    if (!integerPart) {
        integerPart = '0'
    }
    let result = `${integerPart}.`
    if (decimalPart) {
        if (decimalPart.length > 2) {
            decimalPart = decimalPart.slice(0, 2)
        }
        result = result + decimalPart
    }
    return '$' + result
};

export function validateFloatAmount(value: string) {
    // Allow empty input
    if (value === "") {
        return value;
    }
    
    // Filter out any non-numeric characters except decimal point
    if (!/^[\d.]*$/.test(value)) {
        // Remove any non-numeric characters except decimal point
        value = value.replace(/[^\d.]/g, '');
    }
    
    // Handle single decimal point
    if (value === ".") {
        return "0.";
    }
    
    // Split the value into integer and decimal parts
    const parts = value.split('.');
    
    // If there are multiple decimal points, keep only the first one
    if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('');
        parts[1] = parts.slice(1).join('');
    }
    
    // Get the integer part (remove leading zeros by converting to number and back to string)
    let integerPart = parts[0];
    if (integerPart === "") {
        integerPart = "0";
    } else {
        // Convert to integer to remove leading zeros
        integerPart = parseInt(integerPart, 10).toString();
    }
    
    // If there's no decimal part, just return the integer part
    if (parts.length === 1) {
        return integerPart;
    }
    
    // Handle the decimal part (limit to 2 digits)
    let decimalPart = parts[1];
    if (decimalPart.length > 2) {
        decimalPart = decimalPart.substring(0, 2);
    }
    
    // Combine the parts
    return integerPart + "." + decimalPart;
};